<template>
  <div class="index-page">
    <TheAppbar :show-badges="notificationsPermitted" />
    <TheSidebar />

    <v-main>
      <v-container
        class="pa-0"
        fluid
      >
        <v-fade-transition mode="out-in">
          <router-view :key="$route.name" />
        </v-fade-transition>
      </v-container>
    </v-main>

    <v-overlay
      :value="$store.state.isLoading"
      z-index="999"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import TheAppbar from '@/components/TheAppbar.vue';
import TheSidebar from '@/components/TheSidebar.vue';

export default {
  components: { TheSidebar, TheAppbar },

  channels: {
    UserChatMessagesChannel: {
      received(data) {
        this.incrementUnreadMessages(data.chat_id);
        this.sortChatChannelsByNewestMessage(data.chat_id);
      },
    },

    UserNotificationsChannel: {
      received(data) {
        this.incrementUnread();
        if (this.$route.name === 'notifications') {
          this.fetchNotifications();
        }
      },
    },

    UserRolesChannel: {
      received(data) {
        this.updateUserRoles(data.roles);
      },
    },
  },

  computed: {
    ...mapState('auth', [
      'user',
      'token',
    ]),
    ...mapGetters('auth', [
      'checkUserPermissions',
    ]),

    notificationsPermitted() {
      const availability = ['admin_director', 'chief', 'department_director',
       'user', 'graphic', 'editor', 'project_manager', 'print_coordinator', 'guard'];
      return this.checkUserPermissions(availability);
    },
  },

  created() {
    const { id } = this.user;
    this.updateUserData();
    this.connectToWebsocketWithToken();
    this.fetchFiltersOptions();
    this.fetchChannels()
      .then(() => {
        this.$cable.subscribe({
          channel: 'UserChatMessagesChannel',
          id,
        });
      });

    if (this.notificationsPermitted) {
      this.getUnreadNotificationsCount();
      this.$cable.subscribe({
        channel: 'UserNotificationsChannel',
        id,
      });
    }

    this.$cable.subscribe({
      channel: 'UserRolesChannel',
      id,
    });
  },

  methods: {
    ...mapActions('chat', [
      'fetchChannels',
      'incrementUnreadMessages',
      'sortChatChannelsByNewestMessage',
    ]),
    ...mapActions('filters', [
      'fetchFiltersOptions',
    ]),
    ...mapActions('auth', [
      'updateUserRoles',
      'updateUserData',
    ]),
    ...mapActions('notifications', [
      'fetchNotifications',
      'incrementUnread',
      'getUnreadNotificationsCount',
    ]),

    connectToWebsocketWithToken() {
      this.$cable.connection.connect(`${process.env.VUE_APP_WSS_BASE_URL}?Authorization=${this.token}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.index-page {
  background-color: $bg-light;
  min-height: 100vh;
}
</style>
